import { render } from "./WorkStationCard.vue?vue&type=template&id=51f5469b"
import script from "./WorkStationCard.vue?vue&type=script&lang=js"
export * from "./WorkStationCard.vue?vue&type=script&lang=js"

import "./WorkStationCard.vue?vue&type=style&index=0&id=51f5469b&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__